import { jsx as _jsx } from "react/jsx-runtime";
var Crehanaicons172 = function Crehanaicons172(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1 * size,
    height: size,
    viewBox: "0 0 32 32",
    children: /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M16 0c-8.85 0-16 7.15-16 16s7.15 16 16 16c8.85 0 16-7.15 16-16s-7.15-16-16-16zM19.55 13.3l-0.2 2.4h-2.45v8.3h-3.1v-8.3h-1.65v-2.4h1.65v-1.6c0-0.7 0-1.8 0.55-2.5s1.3-1.2 2.55-1.2c2.1 0 2.95 0.3 2.95 0.3l-0.4 2.45c0 0-0.7-0.2-1.35-0.2s-1.2 0.25-1.2 0.85v1.85h2.65z"
    })
  });
};
export default Crehanaicons172;